import styled from 'styled-components';

export const TitleSession = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px;
  color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY};
  background-color: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
  font-weight: 700;
  font-size: 1.2rem;
  margin-bottom: 8px;
  border-radius: 8px 8px 0 0;
`;
